import type {
  ButtonIconSize,
  ButtonIconVariant,
} from '~/components/Button/ButtonIcon/types';

export const MENU_MODAL_ID = 'menu';

export const MENU_BUTTON_PROPS = {
  id: 'mobile-header-menu',
  size: '40-20' as ButtonIconSize,
  variant: 'ghost-grey' as ButtonIconVariant,
  icon: 'menu',
};
